import { render, staticRenderFns } from "./ShopAssembly.vue?vue&type=template&id=88a3d362&scoped=true"
import script from "./ShopAssembly.vue?vue&type=script&lang=js"
export * from "./ShopAssembly.vue?vue&type=script&lang=js"
import style0 from "./ShopAssembly.vue?vue&type=style&index=0&id=88a3d362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a3d362",
  null
  
)

export default component.exports